import React, { useEffect } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'gatsby'
import { ElementHTML } from '@helpers/helper.rendering'

const FullBanner = (props: RealEstateDataPageComponentData) => {
  const {
    fullBanner,
    titleColor,
    titleElement,
    titleHexa,
    backgroundColor,
    backgroundHexa,
    paragraphColor,
    paragraphHexa,
    paragraphElement,
    height,
  } = props

  return (
    <section
      id="full-banner"
      className={'fpb' + (fullBanner?.length === 0 ? ' d-none' : '') + (' ' + backgroundColor)}
      style={{ height: height?.desktop + 'vh' || '100vh', backgroundColor: backgroundHexa }}
    >
      <div className="fp-wrapper">
        <Row className="h-100">
          {fullBanner?.map((b, i) => (
            <Col
              key={i}
              xs={12}
              lg={fullBanner.length > 2 ? 4 : 6}
              className="px-0 border"
            >
              <Link
                to={b?.link!}
                className="fp-link w-100 h-100 d-flex justify-content-center align-items-center position-relative"
              >
                <img
                  src={b?.image!}
                  alt={b?.title}
                  className="fp-img position-absolute w-100 h-100 object-fit-cover z-0"
                />
                <div className="d-flex flex-column align-items-center">
                  <ElementHTML
                    children={b?.subtitle}
                    elementType={paragraphElement || 'h4'}
                    className={'fp-subtitle z-1 ' + paragraphColor}
                    style={{ color: paragraphHexa }}
                  />
                  <ElementHTML
                    children={b?.title}
                    elementType={titleElement || 'h1'}
                    className={'fp-title z-1 ' + titleColor}
                    style={{ color: titleHexa }}
                  />
                  {/* <h4 className="fp-subtitle z-1">{b?.subtitle}</h4>
                  <h1 className="fp-title z-1 text-uppercase">{b?.title}</h1> */}
                  {b?.cta && b?.cta?.length > 0 ? (
                    <button
                      style={{ color: titleHexa, borderColor: titleHexa }}
                      className="fp-cta z-1 mt-3"
                    >
                      {b?.cta}
                    </button>
                  ) : null}
                </div>
              </Link>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  )
}

export default FullBanner
